import { IIconProps } from "./types"

export default function IconVec9(props: IIconProps) {
  const width = props.size || props.width || 38
  const height = props.size || props.height || 25
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 38 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7806 15.0216C22.5076 15.4907 18.2505 15.963 13.8032 15.963C9.37179 15.963 4.76599 15.4908 2.46151 15.2562C0.160198 15.0216 0.160156 15.0216 0.160156 15.0216V10.6504H26.7806V15.0216Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.96678C4.32051 3.48179 8.64106 3 13.1232 3C17.6181 3 22.2746 3.48178 24.6013 3.71952C26.9438 3.96677 26.9437 3.96678 26.9437 3.96678V8.43628H0V3.96678Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.2459 19.8357V12.6908H30.3867L34.2001 6.55078L38.0007 12.6908H35.1542V19.8357H33.2459Z"
        fill="#3A3939"
      />
    </svg>
  )
}
